import { minBreakpoints, theme } from '@noths/polaris-client-ribbons-base';
import { mediaQuery } from '@noths/polaris-client-styles';
import { palette } from '@noths/polaris-design-system-theme-brand2026customer';
import { css } from 'styled-components';

import { commonHeading } from './common.styles';

const { spacing } = theme;

const PANEL_OFFSET = spacing.lg;

export const heading = css`
  ${commonHeading}
  margin: 0 0 ${spacing.md}px 0;

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      text-align: center;
    `,
  )}
`;

export const copy = css`
  ${theme.responsiveText.BODY.MD}
  margin: 0 0 ${spacing.xl + PANEL_OFFSET}px 0;

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      text-align: center;
    `,
  )}

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      ${theme.responsiveText.HEADING.XS}
    `,
  )};
`;

export const partners = css`
  background-color: color-mix(in srgb, ${palette.blueBase} 5%, white);
  padding-bottom: ${spacing.xl}px;
`;
